import { getUrl } from "../../_actions/appConfig.actions";
import { webviewUrl } from "../../_constants";

export function buildBlogArticleURL(handle) {
  return `${getUrl(webviewUrl.WEBVIEW_BLOG)}/${handle}`;
}